import Vue from 'vue'

export default new Vue({
    methods: {
        /**
         * Emits a message to components that are listening
         *
         * @param {String} message
         * @param {String} color
         */
        showMessage (message, color) {
            this.$emit('message-sent', message, color)
        }
    }
})
